import React from "react";
import { useI18n } from "../../lib/i18n";
import { pickLocale } from "../../lib/format";
import { NewsletterSignup } from "../layout/Footer";

/**
 * The newsletter, in the reference design: centred on a beige ground, a large
 * serif heading over a line of support, then the form.
 *
 * The form itself is the signup that already works — same endpoint, same
 * consent checkbox, same subscriber table — so this is a setting for it, not a
 * second implementation of it.
 */
export default function NewsletterBlock({ block }) {
  const { locale, t } = useI18n();
  if (block?.enabled === false) return null;

  const title = pickLocale(block?.title, locale)
    || t("home.newsletter.title", "İlk siz xəbər tutun.");
  const text = pickLocale(block?.text, locale)
    || t("home.newsletter.text", "Yeni kolleksiyalar, qapalı buraxılışlar və Atelier Di Falco hekayələri.");

  return (
    <section className="bg-white py-12 md:py-14 px-6" data-testid="home-newsletter">
      <div className="container mx-auto flex flex-col items-center text-center">
        <h2 className="text-3xl md:text-5xl font-serif mb-6 tracking-tight text-charcoal">{title}</h2>
        <p className="text-sm font-medium mb-12 max-w-lg leading-relaxed text-charcoal/80">{text}</p>
        <div className="w-full max-w-xl text-left">
          <NewsletterSignup tone="light" />
        </div>
      </div>
    </section>
  );
}
